var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPipelineunion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 8,
    viewBox: "0 0 11 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.899414 0V1.17647L2.17392 1.37255L3.25236 1.17647L3.44843 0.723L3.25236 0L0.899414 0Z",
    fill: "#FFDF40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60489 0H3.25195V1.17647L4.42842 1.37255L5.60489 1.17647V0Z",
    fill: "#FFBE40"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.899414 1.17627V5.88215L2.07588 6.07823L3.25236 5.88215L3.44843 3.52921L3.25236 1.17627H0.899414Z",
    fill: "#FFF5F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60489 1.17627H3.25195V5.88215L4.42842 6.07823L5.60489 5.88215V1.17627Z",
    fill: "#ECE6F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.899414 5.88281V7.05928H3.25236L3.44843 6.32399L3.25236 5.88281H0.899414Z",
    fill: "#FFDF40"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25195 5.88281H5.60489V7.05928H3.25195V5.88281Z",
    fill: "#FFBE40"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6047 7.05907V5.8826L9.33015 5.68652L8.25174 5.8826L8.05566 6.33607L8.25174 7.05907H10.6047Z",
    fill: "#FFBE40"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.89941 7.05907H8.25236V5.8826L7.07588 5.68652L5.89941 5.8826V7.05907Z",
    fill: "#FFDF40"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6047 5.88243V1.17655L9.42821 0.980469L8.25174 1.17655L8.05566 3.52949L8.25174 5.88243H10.6047Z",
    fill: "#ECE6F2"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M5.89941 5.88243H8.25236V1.17655L7.07588 0.980469L5.89941 1.17655V5.88243Z",
    fill: "#FFF5F5"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6047 1.17647V0H8.25174L8.05566 0.735294L8.25174 1.17647H10.6047Z",
    fill: "#FFBE40"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.89941 0H8.25236V1.17647H5.89941V0Z",
    fill: "#FFDF40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipelineunion);
export default __webpack_public_path__ + "static/media/pipelineunion.47869b875efd94218c598848b6278eb8.svg";
export { ForwardRef as ReactComponent };